const getIsCurrentSubscription = (subscription) => {
  return (subscription.time_remaining || subscription.timeRemaining) > 0;
};

export default getIsCurrentSubscription;
